import { endOfDay, format, isBefore, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

const ars = new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 });

export function formatARS(n: number | null | undefined): string {
  if (n === null || n === undefined || Number.isNaN(n)) return 'No disponible';
  return ars.format(Math.round(n));
}

export function formatPct(n: number | null | undefined, empty = 'No informado'): string {
  if (n === null || n === undefined) return empty;
  return `${n.toLocaleString('es-AR', { maximumFractionDigits: 2 })}%`;
}

export function formatDate(iso: string): string {
  try {
    return format(parseISO(iso), "d 'de' MMM yyyy", { locale: es });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso: string): string {
  try {
    return format(parseISO(iso), 'dd/MM/yyyy HH:mm');
  } catch {
    return iso;
  }
}

export function isExpired(iso: string): boolean {
  try {
    return isBefore(endOfDay(parseISO(iso)), new Date());
  } catch {
    return true;
  }
}

export function isWithin(startIso: string, endIso: string): boolean {
  try {
    const now = new Date();
    return !isBefore(now, parseISO(startIso)) && !isExpired(endIso);
  } catch {
    return false;
  }
}
